import { useEffect, useState } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";
import { Hero } from "./components/landing/Hero";
import { Marquee } from "./components/landing/Marquee";
import { ProblemSection } from "./components/landing/ProblemSection";
import { PackageSection } from "./components/landing/PackageSection";
import { PricingSection } from "./components/landing/PricingSection";
import { AboutSection } from "./components/landing/AboutSection";
import { TestimonialsSection } from "./components/landing/TestimonialsSection";
import { FaqSection } from "./components/landing/FaqSection";
import { NewsletterSection } from "./components/landing/NewsletterSection";
import { Footer } from "./components/landing/Footer";
import { NewsletterPopup } from "./components/landing/NewsletterPopup";
import { SocialProofToast } from "./components/landing/SocialProofToast";
import { StickyCta } from "./components/landing/StickyCta";
import { TermsModal } from "./components/landing/TermsModal";
import { ThankYou } from "./pages/ThankYou";
import { TermsPage } from "./pages/TermsPage";
import { PrivacyPage } from "./pages/PrivacyPage";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const Landing = ({ onBuy }) => (
  <>
    <Hero onBuy={onBuy} />
    <Marquee />
    <ProblemSection onBuy={onBuy} />
    <PackageSection onBuy={onBuy} />
    <TestimonialsSection onBuy={onBuy} />
    <PricingSection onBuy={onBuy} />
    <AboutSection onBuy={onBuy} />
    <FaqSection onBuy={onBuy} />
    <NewsletterSection />
    <Footer />
    <NewsletterPopup />
    <SocialProofToast />
    <StickyCta onBuy={onBuy} />
  </>
);

function App() {
  const [termsOpen, setTermsOpen] = useState(false);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09 });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <BrowserRouter>
      <ScrollToTop />
      <div className="min-h-screen bg-cream font-sans text-choc">
        <Routes>
          <Route path="/" element={<Landing onBuy={() => setTermsOpen(true)} />} />
          <Route path="/podziekowanie" element={<ThankYou />} />
          <Route path="/regulamin" element={<TermsPage />} />
          <Route path="/polityka-prywatnosci" element={<PrivacyPage />} />
        </Routes>
        <TermsModal open={termsOpen} onClose={() => setTermsOpen(false)} />
        <div className="grain" aria-hidden="true" />
      </div>
    </BrowserRouter>
  );
}

export default App;
